import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ToastService, ProjectService} from '../../services';
import {TranslateService} from '@ngx-translate/core';
import {ProjectDetails} from '../../models';

@Component({
    selector: 'app-delete-project-modal',
    templateUrl: './delete-project-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteProjectModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig = inject<VwuiModalConfig<{ projectDetails: ProjectDetails; }>>(VwuiModalConfig);
    private projectService = inject(ProjectService);
    private translateService = inject(TranslateService);
    private toastService = inject(ToastService);


    public loading = false;

    async submit() {

        this.loading = true;
        this.projectService.toArchived(this.modalConfig.data.projectDetails)
            .then((_) => {
                const message = this.translateService.instant('DELETE_PROJECT.modal.success');
                this.toastService.openSuccess(message);
                this.modalRef.close(true);
            })
            .catch((error) => {
                console.error(error);
                this.toastService.openError(error, this.translateService.instant('ERRORS.project_to_archived_nok'));
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
